module.exports = __webpack_public_path__ + "img/tu_1.e6dec8b5.png";